import { type Type, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgComponentOutlet } from '@angular/common';

@Component({
  selector: 'cappus-component-wrapper-dialog',
  imports: [NgComponentOutlet],
  templateUrl: './component-wrapper-dialog.component.html',
  styleUrl: './component-wrapper-dialog.component.scss',
})
export class ComponentWrapperDialogComponent<T> {
  protected component!: Type<T>;
  protected inputParams!: Partial<T>;
  readonly data: { component: Type<T>; inputParams: Partial<T> } = inject(MAT_DIALOG_DATA);

  constructor() {
    this.component = this.data.component;
    this.inputParams = {
      ...this.data.inputParams,
    };
  }
}
